import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const FAQSection = () => {
  const faqs = [
    {
      question: 'What size of businesses do you acquire?',
      answer: 'We typically acquire businesses generating $200K to $2M in annual revenue, or more than $40K in annual profits. If you\'re in that range and the business is boring enough, we\'re interested.'
    },
    {
      question: 'What are the typical valuation multiples?',
      answer: 'It depends on a few things — operating history, stability of cash flows, SKU concentration risk, review quality, and how competitive the niche is. That said, our range usually sits between 1x–2.5x annual SDE (seller discretionary earnings). We\'ll always be upfront about how we get to a number.'
    },
    {
      question: 'Do you require earnouts?',
      answer: 'Sometimes, depending on the deal structure. But we prioritize clean cash exits wherever possible, with minimal involvement needed from the founder beyond a short transition period — usually around one month.'
    },
    {
      question: 'Is this confidential?',
      answer: 'Yes. Always. We do not share your information with anyone without your explicit permission. No exceptions.'
    }
  ];

  return (
    <section id="faqs" className="py-24 md:py-32 bg-[#F5F0EB] px-6 md:px-12">
      <div className="max-w-4xl mx-auto">
        <h2 
          className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#1B4D3E] mb-16"
          style={{fontFamily: 'Space Grotesk, sans-serif'}}
        >
          Questions we get a lot.
        </h2>

        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="border-b border-[#E0D8CF] pb-4"
            >
              <AccordionTrigger 
                className="text-left text-xl font-bold text-[#1B4D3E] hover:opacity-70 py-4 no-underline"
                style={{fontFamily: 'Space Grotesk, sans-serif'}}
              >
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-lg text-[#2C2C2C] leading-relaxed pt-2">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQSection;